module.exports = __webpack_public_path__ + "img/ortovitalli.3920e7d2.webp";